import { IUpdateInformacoesEntregaObraClienteUseCase } from "../../../presentation/useCases/update/update_informacoes_entrega_obra_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateInformacoesEntregaObraClienteUseCase
 */

export class UpdateInformacoesEntregaObraClienteUseCase implements IUpdateInformacoesEntregaObraClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idInformacoesEntregaObraCliente: number,
    idEntregaObraCliente?: number,
    idVerificacaoChecklist?: number,
    dataDescricao?: Date,
    dataTratativa?: Date,
    descricao?: string,
    tratativa?: string,
    inspecao?: number,

    descricaoArquivo?: string,
    arquivo?: File,
    limparArquivo?: boolean,

    descricaoArquivo2?: string,
    arquivo2?: File,
    limparArquivo2?: boolean

  ): Promise<void> {
    const computedNomeArquivo = arquivo ? arquivo.name : undefined;
    const computedArquivo = arquivo ? arquivo : undefined;

    const computedNomeArquivo2 = arquivo2 ? arquivo2.name : undefined;
    const computedArquivo2 = arquivo2 ? arquivo2 : undefined;

    await this.repository.updateInformacoesEntregaObrasCliente(
      idInformacoesEntregaObraCliente,
      idEntregaObraCliente,
      idVerificacaoChecklist,
      dataDescricao,
      dataTratativa,
      descricao,
      tratativa,
      inspecao,

      descricaoArquivo,
      computedNomeArquivo,
      computedArquivo,
      limparArquivo,

      descricaoArquivo2,
      computedNomeArquivo2,
      computedArquivo2,
      limparArquivo2,
    );
  }
}
